import { StockEntity, StockCategoryEntity, StockPlaceEntity } from '../types/data';

// ストックカテゴリのモックデータ
export const stockCategoriesData: StockCategoryEntity[] = [
  {
    id: 'stock-cat-1',
    title: '食材',
    body: '日常の食材',
    created_at: '2025-01-01T09:00:00.000Z',
    modified_at: '2025-01-01T09:00:00.000Z',
    is_deleted: false,
    sort_order: 1000,
  },
  {
    id: 'stock-cat-2',
    title: '日用品',
    body: '生活用品',
    created_at: '2025-01-01T09:00:00.000Z',
    modified_at: '2025-01-01T09:00:00.000Z',
    is_deleted: false,
    sort_order: 2000,
  },
  {
    id: 'stock-cat-3',
    title: '文房具',
    body: 'オフィス用品',
    created_at: '2025-01-01T09:00:00.000Z',
    modified_at: '2025-01-01T09:00:00.000Z',
    is_deleted: false,
    sort_order: 3000,
  },
  {
    id: 'stock-cat-4',
    title: '衣類',
    body: '服飾関連',
    created_at: '2025-01-01T09:00:00.000Z',
    modified_at: '2025-01-01T09:00:00.000Z',
    is_deleted: false,
    sort_order: 4000,
  },
];

export const stockPlacesData: StockPlaceEntity[] = [
  {
    id: 'stock-place-1',
    title: 'キッチン棚',
    body: '乾物と保存食',
    created_at: '2025-01-01T09:00:00.000Z',
    modified_at: '2025-01-01T09:00:00.000Z',
    is_deleted: false,
    sort_order: 1000,
  },
  {
    id: 'stock-place-2',
    title: 'キッチンシンク',
    body: '洗剤やスポンジ',
    created_at: '2025-01-01T09:00:00.000Z',
    modified_at: '2025-01-01T09:00:00.000Z',
    is_deleted: false,
    sort_order: 2000,
  },
  {
    id: 'stock-place-3',
    title: '洗面所',
    body: '衛生用品',
    created_at: '2025-01-01T09:00:00.000Z',
    modified_at: '2025-01-01T09:00:00.000Z',
    is_deleted: false,
    sort_order: 3000,
  },
  {
    id: 'stock-place-4',
    title: '廊下ストッカー',
    body: '日用品の予備',
    created_at: '2025-01-01T09:00:00.000Z',
    modified_at: '2025-01-01T09:00:00.000Z',
    is_deleted: false,
    sort_order: 4000,
  },
];

// ストックのモックデータ
export const stocksData: StockEntity[] = [
  {
    id: 'stock-1',
    title: '米',
    body: '5kg',
    where_to_get: 'スーパー',
    count: 1,
    created_at: '2025-01-01T10:00:00.000Z',
    modified_at: '2025-01-01T10:00:00.000Z',
    is_deleted: false,
    stock_category_id: 'stock-cat-1',
    stock_place_id: 'stock-place-1',
    sort_order: 1000,
  },
  {
    id: 'stock-2',
    title: '卵',
    body: '1パック',
    where_to_get: 'スーパー',
    count: 0,
    created_at: '2025-01-01T10:30:00.000Z',
    modified_at: '2025-01-01T10:30:00.000Z',
    is_deleted: false,
    stock_category_id: 'stock-cat-1',
    stock_place_id: 'stock-place-2',
    sort_order: 2000,
  },
  {
    id: 'stock-3',
    title: '牛乳',
    body: '1リットル',
    where_to_get: 'スーパー',
    count: 2,
    created_at: '2025-01-01T11:00:00.000Z',
    modified_at: '2025-01-01T11:00:00.000Z',
    is_deleted: false,
    stock_category_id: 'stock-cat-1',
    stock_place_id: 'stock-place-1',
    sort_order: 3000,
  },
  {
    id: 'stock-4',
    title: 'シャンプー',
    body: 'ファミリーサイズ',
    where_to_get: 'ドラッグストア',
    count: 1,
    created_at: '2025-01-01T11:30:00.000Z',
    modified_at: '2025-01-01T11:30:00.000Z',
    is_deleted: false,
    stock_category_id: 'stock-cat-2',
    stock_place_id: 'stock-place-3',
    sort_order: 1000,
  },
  {
    id: 'stock-5',
    title: 'ティッシュ',
    body: '5箱パック',
    where_to_get: 'ドラッグストア',
    count: 2,
    created_at: '2025-01-01T12:00:00.000Z',
    modified_at: '2025-01-01T12:00:00.000Z',
    is_deleted: false,
    stock_category_id: 'stock-cat-2',
    stock_place_id: 'stock-place-4',
    sort_order: 2000,
  },
  {
    id: 'stock-6',
    title: 'ボールペン',
    body: '黒、青、赤各1本',
    where_to_get: '文具店',
    count: 3,
    created_at: '2025-01-01T12:30:00.000Z',
    modified_at: '2025-01-01T12:30:00.000Z',
    is_deleted: false,
    stock_category_id: 'stock-cat-3',
    stock_place_id: undefined,
    sort_order: 1000,
  },
  {
    id: 'stock-7',
    title: 'コピー用紙',
    body: 'A4 500枚',
    where_to_get: 'オフィス用品店',
    count: 1,
    created_at: '2025-01-01T13:00:00.000Z',
    modified_at: '2025-01-01T13:00:00.000Z',
    is_deleted: false,
    stock_category_id: 'stock-cat-3',
    stock_place_id: 'stock-place-4',
    sort_order: 2000,
  },
  {
    id: 'stock-8',
    title: 'Tシャツ',
    body: 'サイズL、白',
    where_to_get: '衣料品店',
    count: 2,
    created_at: '2025-01-01T13:30:00.000Z',
    modified_at: '2025-01-01T13:30:00.000Z',
    is_deleted: false,
    stock_category_id: 'stock-cat-4',
    stock_place_id: undefined,
    sort_order: 1000,
  },
];
